import { render, staticRenderFns } from "./InvoiceDetailPage.vue?vue&type=template&id=5cb93bdf&scoped=true&"
import script from "./InvoiceDetailPage.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetailPage.vue?vue&type=style&index=0&id=5cb93bdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb93bdf",
  null
  
)

export default component.exports